/** 숫자만 남기고 최대 길이로 자릅니다. */
export function digitsOnly(value, maxLen) {
  const d = String(value ?? '').replace(/\D/g, '')
  return maxLen != null ? d.slice(0, maxLen) : d
}

/**
 * 백엔드 ClaimPhoneUtils.normalizeKoreanPhoneDigits 와 동일 규칙(+82·0082 처리, 선행 0 보정).
 */
export function normalizeKoreanPhoneDigits(raw) {
  if (raw == null || raw === '') return ''
  let n = String(raw).replace(/\D/g, '')
  if (!n) return ''
  if (n.startsWith('0082') && n.length >= 12) {
    n = n.slice(4)
  } else if (n.startsWith('82') && n.length >= 11) {
    n = n.slice(2)
  }
  if (n && !n.startsWith('0')) {
    n = `0${n}`
  }
  return n
}

/**
 * 비어 있으면 true. 값이 있으면 정규화 후 9~11자리(백엔드 ClaimPhoneUtils.isValidKoreanClaimPhone 와 동일).
 */
export function isValidKoreanClaimPhone(raw) {
  if (raw == null || String(raw).trim() === '') return true
  const n = normalizeKoreanPhoneDigits(raw)
  return n.length >= 9 && n.length <= 11
}

/** 주민등록번호: 123456-1234567 형태(저장값은 숫자만) */
export function formatResidentDisplay(digits) {
  const d = digitsOnly(digits, 13)
  if (!d) return ''
  if (d.length <= 6) return d
  return `${d.slice(0, 6)}-${d.slice(6)}`
}

/**
 * 휴대전화·유선: 010-1234-5678 등(저장값은 숫자만).
 * 02 지역번호 10자리는 02-XXXX-XXXX 로 묶습니다.
 */
export function formatPhoneDisplay(digits) {
  const d = digitsOnly(digits, 11)
  if (!d) return ''
  if (d.length <= 3) return d
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`
  if (d.length === 10 && d.startsWith('02')) {
    return `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6)}`
  }
  if (d.length === 10) {
    return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`
  }
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7, 11)}`
}

/** 브라우저 로컬 날짜 기준 yyyy-MM-dd */
export function todayYmdLocal() {
  const t = new Date()
  const y = t.getFullYear()
  const m = String(t.getMonth() + 1).padStart(2, '0')
  const day = String(t.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/**
 * 주민등록번호 앞 6자리와(가능하면) 7번째 성별·세기 코드로 생년월일 yyyy-MM-dd 추정.
 * 7자리 미만이면 YY와 현재 연도의 끝 두 자리를 비교해 19/20세기를 추정합니다.
 */
export function birthDateYmdFromResidentDigits(value) {
  const id = digitsOnly(value, 13)
  if (id.length < 6) return ''
  const yy = id.slice(0, 2)
  const mm = id.slice(2, 4)
  const dd = id.slice(4, 6)
  if (!/^\d{2}$/.test(yy) || !/^\d{2}$/.test(mm) || !/^\d{2}$/.test(dd)) return ''
  const mmN = Number(mm)
  const ddN = Number(dd)
  if (mmN < 1 || mmN > 12) return ''
  if (ddN < 1 || ddN > 31) return ''

  let century = ''
  if (id.length >= 7) {
    const g = id[6]
    if (g === '1' || g === '2' || g === '5' || g === '6') century = '19'
    else if (g === '3' || g === '4' || g === '7' || g === '8') century = '20'
    else if (g === '9' || g === '0') century = '18'
  }
  if (!century) {
    const yyN = Number(yy)
    const nowYY = Number(String(new Date().getFullYear()).slice(-2))
    century = yyN >= 0 && yyN <= nowYY ? '20' : '19'
  }

  const y = Number(`${century}${yy}`)
  const check = new Date(y, mmN - 1, ddN)
  if (check.getFullYear() !== y || check.getMonth() !== mmN - 1 || check.getDate() !== ddN) return ''
  return `${century}${yy}-${mm}-${dd}`
}

/** yyyy-MM-dd → 주민등록번호 앞 6자리(YYMMDD). 뒷자리는 성별·세기 정보가 없어 비워 둡니다. */
export function residentDigitsPrefixFromBirthDateYmd(birthDateYmd) {
  const m = String(birthDateYmd || '').match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!m) return ''
  const yyyy = Number(m[1])
  const mm = Number(m[2])
  const dd = Number(m[3])
  if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return ''
  const check = new Date(yyyy, mm - 1, dd)
  if (check.getFullYear() !== yyyy || check.getMonth() !== mm - 1 || check.getDate() !== dd) return ''
  return `${String(yyyy).slice(-2)}${m[2]}${m[3]}`
}
